import './modules/polyfills';
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import * as Utils from './modules/utils';
import * as Sliders from './modules/sliders';
import './modules/navigation';
import * as Ajax from './modules/ajax';

function ArchivesLoader(archives) {

	this.$container = archives;
	this.loading = false;

	this.determineType();
	this.begin();

}

ArchivesLoader.prototype.determineType = function() {
	this.isDiscover = this.$container[0].classList.contains('js-discover') ? true : false;
	this.hasFilters = this.$container[0].classList.contains('js-filters-active') ? true : false;
}

ArchivesLoader.prototype.onScroll = function() {
		this.checkForLoad();
	};

ArchivesLoader.prototype.checkForLoad = function() {
	if (this.loading) { return; }

	// If we are at the target point
	if (winScrollT >= this.scrollTarget) {

		this.load();
	}

}

ArchivesLoader.prototype.calcTarget = function() {

	// Half the winH before we're right at the bottom of the container
	this.scrollTarget = Math.round(this.$container.offset().top + this.$container.innerHeight() - winH * 2);

};

ArchivesLoader.prototype.onScroll = function() {
	this.checkForLoad();
};

ArchivesLoader.prototype.onResize = function() {
	this.calcAndCheck();
};

ArchivesLoader.prototype.begin = function() {

	if ( this.hasFilters ) {
		this.setUpFilters('.js-mobile-filters');
	}

	this.currentFilter = this.$container[0].dataset.category;

	this.preLoad();
	this.calcAndCheck();
};

ArchivesLoader.prototype.calcAndCheck = function() {
	this.calcTarget();
	this.checkForLoad();
};

ArchivesLoader.prototype.setUpFilters = function(filters) {
	$(filters).bind('change', function () {
          var url = $(this).val(); // get selected value
          if (url) { // require a URL
              window.location = url; // redirect
          }
          return false;
      });

	if (this.isDiscover) {

	$('.js-discover-filter').on('click', function(e) {
				e.preventDefault();
				var $target = $(e.currentTarget),
					href = $target.attr('href'),
					check = window.location.href;

				if (href == check) {
						return;
					}

				var cat = $target[0].dataset.category;
				this.data = {'action':'loadmore','offset' : '','live-tag' : cat },
				this.ajaxUrl = siteUrl + '/wp-admin/admin-ajax.php';

				$('.js-post-container').addClass('loading');

				this.currentFilter = cat;
				window.history.pushState({ url: href }, null, href);

				$('.discover__filter-list li.active').removeClass('active');
				$("li[data-topic='" + cat +"']").addClass('active');

				this.xhr = $.post(this.ajaxUrl, this.data, this.switchFilter.bind(this));

			}.bind(this));

		} else {

			$('.js-think-filter').on('click', function(e) {
						e.preventDefault();
						var $target = $(e.currentTarget),
							href = $target[0].getAttribute('href'),
							check = window.location.href;

						if (href == check) {
								return;
							}

						var	livetag = $target[0].dataset.category;

						this.data = {'action':'archivesload','offset' : '','live-tag' : livetag,'type':'tag' },
						this.ajaxUrl = siteUrl + '/wp-admin/admin-ajax.php';

						$('.js-post-container').addClass('loading');

						this.currentFilter = livetag;
						window.history.pushState({ url: href }, null, href);

						$('.discover__filter-list li.active').removeClass('active');
						$("li[data-topic='" + livetag +"']").addClass('active');

						this.xhr = $.post(this.ajaxUrl, this.data, this.switchFilter.bind(this));

					}.bind(this));

		}

}

ArchivesLoader.prototype.switchFilter = function(returnData) {

	$('.js-post-container').html(returnData);

	Global.onElsAppended(returnData, this);

	this.loading = false;

	$('.js-post-container').removeClass('loading');

	this.preLoad();

}

ArchivesLoader.prototype.preLoad = function() {

	if (this.isDiscover) {

		var offset = $('.js-collective-block').length,
			livetag = this.currentFilter;
			this.data = {'action':'loadmore','offset' : offset,'live-tag' : livetag };
			this.ajaxUrl = siteUrl + '/wp-admin/admin-ajax.php';

	} else {

	var offset = $('.js-post').length,
			livetag = this.currentFilter,
			type = this.$container.data('type');
			this.data = {'action':'archivesload','offset' : offset,'live-tag' : livetag,'type':type };
			this.ajaxUrl = siteUrl + '/wp-admin/admin-ajax.php';

		}

		this.loading = true;

		this.xhr = $.post(this.ajaxUrl, this.data, this.handleReturnData.bind(this));

}


ArchivesLoader.prototype.load = function() {

	$('.js-post-container').append(this.returnData);

	Global.onElsAppended(this.returnData, this);

	this.preLoad();

	this.calcAndCheck();

	};


ArchivesLoader.prototype.handleReturnData = function(returnData) {

		this.returnData = returnData;

		this.loaded = true;
		this.loading = false;

}


function ImgLoadHandler($page) {

	this.$page = $page;

	this.searchForImages($page);

}

ImgLoadHandler.prototype.imgClass = 'js-img-load';

ImgLoadHandler.prototype.searchForImages = function($page) {
	var $containers = $page.find('.js-img-load');
	for (var i = 0; i < $containers.length; i++) {
		this.loadImage($containers[i]);
	}
}

ImgLoadHandler.prototype.loadImage = function($container) {
	imagesLoaded($container, () => {
			let imgs = $container.querySelectorAll('.ease-in');
			$container.classList.remove('preload');
			$(imgs).addClass('loaded');
		});
}

ImgLoadHandler.prototype.onElsAppended = function($els) {
	var $containers = $body.find('.preload');
	for (var i = 0; i < $containers.length; i++) {
		this.loadImage($containers[i]);
	}

}



function processPatrons() {
	var patronLevel = $('.js-patron-level'),
		backButton = $('.js-close-lightbox'),
		addButton = $('.signup__info.button');

	function patronLightbox() {
		var id = $(this).data('id');
		$('.signup__option').removeClass('active');
		$('.signup__info').removeClass('active');
		$('.' + id).addClass('active');
	}

	function closeLightbox() {
		$('.signup__option').removeClass('active');
		$('.signup__info').removeClass('active');
	}

	$(addButton).click(function(event) {
		event.preventDefault();
		var variation = $(this).data('variation');
		var amount = $('.nyp.' + variation).val();
		var url = 'https://sptnk.co.uk/cart/?add-to-cart=7524&variation_id=' + variation + '&nyp=' + amount,
			show = 'https://sptnk.co.uk/cart/';
		 window.location = url;
		 window.history.replaceState({ url: show }, null, show);
	});

	$(patronLevel).click(patronLightbox);
	$(backButton).click(closeLightbox);

}

function handleMenu() {

var Menu = function() {
	$('.menu__overlay').toggleClass('active');
	$body.toggleClass('menu-active');
}
var Search = function() { $('.search__overlay').toggleClass('active'); }
var Faq = function() {
	$(this).parent().next().toggleClass('open');
}

$('.js-menu-trigger').click(Menu);
$('.js-search-trigger').click(Search);
$('.js-faq-question').click(Faq);
}

function initGeneralListeners() {
	$win.on('scroll', function() {
		runGeneralFns(onScrollGeneralFns);
		Global.onScroll();
	});

	$win.on('resize', function() {
		runGeneralFns(onResizeGeneralFns);
		Global.onResize();
	});

	$('.js-newsletter').on('click', function() {
		var newsletter = document.querySelector("#newsletter");
		newsletter.scrollIntoView({ behavior: 'smooth'});
		$('.menu__overlay').removeClass('active');
	});

	$('.js-hub-search').on('click', function() {
		var hubsearch = document.querySelector("#hub-search");
		hubsearch.scrollIntoView({ behavior: 'smooth'});
	});

}

function runGeneralFns(fns) {
		fns.forEach(function(fn) {
			fn();
		});
	}

function updateWinScrollT(val) {
	if (!val) {
		val = $win.scrollTop();
	}

	winScrollT = val;
}

function updateWinH() {
	winH = $win.height();
	let vh = window.innerHeight * 0.01;
		document.documentElement.style.setProperty('--vh', `${vh}px`);
}

function updateWinW() {
	winW = $win.width();
}

var $win = $(window),
	$body = $('body'),
	winH,
	winW,
	winScrollT,
	onScrollGeneralFns = [updateWinScrollT],
	onResizeGeneralFns = [updateWinW, updateWinH],
	siteUrl = document.location.origin,
	Global = {
				handlers: [],
        build: function() {
					var handlers = [],
							connectTest = $('#contactform'),
							carousel = $('.js-carousel'),
							archives = $('.js-archive'),
							patronsTest = $('.js-patron-level'),
							$imgLoader = $('.js-img-load');

				if (connectTest.length) { handleConnectForm(); }
				if (patronsTest.length) { processPatrons(); }
				if (archives.length) { handlers.push(new ArchivesLoader(archives)); }
				if (carousel.length) { handlers.push(new InlineCarouselHandler($body)); }
				if ($imgLoader.length) { handlers.push(new ImgLoadHandler($body)); }
				// For each of them
				for (var i = 0; i < handlers.length; i++) {
					// Assign them to this layer's handlers array
					Global.handlers.push(handlers[i]);
				}
				handleMenu();

				// $('body').imagesLoaded( function() {
				$body.addClass('loaded');
				Utils.showPage();
          //  });
        },
				onScroll: function() {
						this.runHandlersFn('onScroll');
				},
				onResize: function() {
					this.runHandlersFn('onResize');
				},
				onElsAppended: function(newEls, callingObj) {
						this.runHandlersFn('onElsAppended', newEls, callingObj);
						Utils.animateInViewEls('.js-watch', 'in-view', 0.1);
				},
				runHandlersFn: function(fn, els, callingObj) {
					// For each handler
					for (var i = 0; i < this.handlers.length; i++) {
						// If this handler has this method
						if (typeof this.handlers[i][fn] === 'function') {
							// Call it
							this.handlers[i][fn](els, callingObj);
						}
					}
				}
    };

updateWinScrollT();
updateWinH();
updateWinW();

initGeneralListeners();

Global.build();

// Ajax load more
if (document.querySelector('.js-load-more-posts')) {
    Ajax.init();
}
